import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { ICompany } from "@common/interfaces/company";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";

export interface CompanyState extends EntityState<ICompany, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.COMPANIES , realtimeEntity: 'Company'})
export class CompanyStore extends EntityStore<CompanyState> {
  constructor() {
    super([]);
  }
}
